/**
 * @fileoverview UserPanel.jsx - Versión REFACTORIZADA
 * Header extraído a componente separado
 * ✅ Reducido de 1195 → ~700 líneas
 * ✅ Sin referencias a avatar1
 */

import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAutoLogout from './hooks/useAutoLogout';
import SessionWarningModal from './components/SessionWarningModal';

// Assets
import SoportePanel from "../components/Soporte/SoportePanel";

// Componentes
import { ObjectCard, UserPanelModals } from "./components/UserPanelContent";
import UserPanelHeader from "./components/UserPanelHeader";
import MiAgendaModal from "./components/MiAgendaModal";

// Helpers
import { tieneAccesoA } from "../utils/planUtils";

// Hooks
import { useUserActions } from "./hooks/useUserActions";
import { useObjectActions } from "./hooks/useObjectActions";

// API
import {
  actualizarVeterinario,
  reInvitarVeterinario,
  obtenerVeterinariosDeUsuario,
  invitarVeterinarioAUsuario,
  eliminarVeterinarioDeUsuario,
} from "../services/api/modules/vets";
import { obtenerAgendaCount } from "../services/api/modules/agenda";

// Campos para recompensas
const LOST_ITEM_FIELDS = [
  {
    fieldKey: "recompensaOfrecida",
    label: "Recompensa Ofrecida",
    inputType: "text",
    placeholder: "Ej. $500 o una tarjeta de regalo",
    validation: ["required"],
  },
];

// Campos para perfil público de búsqueda
const PUBLIC_PROFILE_FIELDS = [
  {
    fieldKey: "ubicacionPerdida",
    label: "¿Dónde se perdió?",
    inputType: "google-places",
    placeholder: "Ej. Parque México, Colonia Roma Norte",
    validation: [],
    helperText: "Zona aproximada donde crees que se perdió",
  },
  {
    fieldKey: "fechaPerdida",
    label: "¿Cuándo se perdió?",
    inputType: "date",
    validation: [],
  },
  {
    fieldKey: "queLlevabaPuesto",
    label: "¿Qué llevaba puesto?",
    inputType: "text",
    placeholder: "Ej. Collar azul, arnés rojo, placa con nombre...",
    validation: [],
    helperText: "Descripción de accesorios visibles",
  },
  {
    fieldKey: "dondeBuscar",
    label: "¿Dónde buscarlo?",
    inputType: "textarea",
    placeholder: "Ej. Suele ir al parque de enfrente, le gustan los puestos de comida...",
    validation: [],
    helperText: "Lugares donde podría encontrarse",
  },
  {
    fieldKey: "queProvocoEscape",
    label: "¿Qué provocó la huida?",
    inputType: "textarea",
    placeholder: "Ej. Se asustó con cohetes, se soltó de la correa, se salió por la puerta...",
    validation: [],
    helperText: "Contexto que ayude a entender su comportamiento",
  },
];

// Lista de avatares disponibles
// ✅ CORREGIDO: Quitado avatar1
const avatarsDisponibles = [
  require("../assets/avatars/boy_434997.png"),
  require("../assets/avatars/girl_2632263.png"),
  require("../assets/avatars/superhero_7024072.png"),
  require("../assets/avatars/otaku_1888233.png"),
  require("../assets/avatars/pirate_1923035.png"),
  require("../assets/avatars/devil.png"),
  require("../assets/avatars/mummy.png"),
  require("../assets/avatars/elf_.png"),
  require("../assets/avatars/frankenstein.png"),
  require("../assets/avatars/cat.png"),
  require("../assets/avatars/little-red-riding-hood.png"),
  require("../assets/avatars/pilot.png")
];

export default function UserPanel(props) {
  const {
    usuario,
    objetos,
    cargando,
    errorUsuario,
    errorObjetos,
    setUsuario,
    setObjetos,
  } = props;

  // ✅ CORREGIDO: Sin urlAvatar fallback
  const usuarioSeguro = usuario ? {
    ...usuario,
    ownerId: usuario.ownerId || usuario.id || '',
    token: usuario.token || '',
    nombrePropietario: usuario.nombrePropietario || 'Usuario',
    correoVerificado: usuario.correoVerificado !== undefined ? usuario.correoVerificado : true,
    correoPropietario: usuario.correoPropietario || ''
  } : null;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Estados principales
  const [activeFilter, setActiveFilter] = useState('todos');
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [veterinarios, setVeterinarios] = useState([]);
  const [vetLimites, setVetLimites] = useState(null);

  // Estados de modales
  const [showModalDatos, setShowModalDatos] = useState(false);
  const [showModalAvatar, setShowModalAvatar] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showLostItemForm, setShowLostItemForm] = useState(false);
  const [showVetList, setShowVetList] = useState(false);
  const [showRewardModal, setShowRewardModal] = useState(false);
  const [showProvidersList, setShowProvidersList] = useState(false);
  const [showLockModal, setShowLockModal] = useState(false);
  const [showAgenda, setShowAgenda] = useState(false);
  const [agendaCount, setAgendaCount] = useState(0);
  const [showPublicProfileModal, setShowPublicProfileModal] = useState(false);
  const [showPublicProfileForm, setShowPublicProfileForm] = useState(false);
  const [showPublicProfileSuccess, setShowPublicProfileSuccess] = useState(false);

  // Estados de datos para modales
  const [userFormData] = useState({});
  const [objToEdit, setObjToEdit] = useState(null);
  const [lostItemData, setLostItemData] = useState({});
  const [publicProfileData, setPublicProfileData] = useState({});
  const [objToMarkLost, setObjToMarkLost] = useState(null);
  const [objToLock, setObjToLock] = useState(null);
  // Track if reward was collected (to pass through the flow)
  const [pendingRewardData, setPendingRewardData] = useState(null);

  // Hooks personalizados
  const { saveUserData, changeAvatar } =
    useUserActions(usuarioSeguro, setUsuario);
  const { submitEditObject, reportLostOrFound, submitLostItem, submitPublicProfile, toggleLock } =
    useObjectActions(setObjetos);
    const { showWarning, secondsRemaining, extendSession, logoutNow } = useAutoLogout();


  // Lógica para filtros inteligentes
  const availableCategories = useMemo(() => {
    if (!objetos || objetos.length === 0) return [];
    const types = new Set(objetos.map(obj => obj.tipo || 'objeto'));
    return Array.from(types);
  }, [objetos]);

  const filteredObjects = useMemo(() => {
    if (activeFilter === 'todos') return objetos;
    return objetos.filter(obj => (obj.tipo || 'objeto') === activeFilter);
  }, [objetos, activeFilter]);

  // Efectos
  useEffect(() => {
    const docParam = searchParams.get("doc");
    const tokenParam = searchParams.get("token");
    
    if (tokenParam) {
      localStorage.setItem('nfcToken', tokenParam);
    }

    if (docParam || tokenParam) {
      setUsuario((prev) => ({
        ...prev,
        ...(docParam && { ownerId: docParam }),
        ...(tokenParam && { token: tokenParam })
      }));
    }
  }, [searchParams, setUsuario]);

  useEffect(() => {
    if (usuarioSeguro?.ownerId && objetos && !errorObjetos) {
      loadVeterinariosDeUsuario()
        .catch((err) => console.error("Error cargando veterinarios:", err));
    }
  }, [usuarioSeguro?.ownerId, objetos, errorObjetos]);

  // Fetch agenda count for badge
  const fetchAgendaCount = React.useCallback(async () => {
    const result = await obtenerAgendaCount();
    setAgendaCount(result.count || 0);
  }, []);

  useEffect(() => {
    if (usuarioSeguro?.ownerId) {
      fetchAgendaCount();
    }
  }, [usuarioSeguro?.ownerId, fetchAgendaCount]);

  // Botón "back" siempre lleva a home, si ya está en home no hace nada
  // Usa múltiples entradas de historial como "colchón" para prevenir salida
  useEffect(() => {
    const handlePopState = (event) => {
      // Prevenir comportamiento por defecto
      event.preventDefault();

      const currentPath = window.location.pathname;

      // Verificar si estamos en home
      const isHome = currentPath === '/userpanel' ||
                     currentPath === '/' ||
                     currentPath.endsWith('/userpanel');

      // Si NO estamos en home, navegar a home
      if (!isHome) {
        navigate('/userpanel', { replace: true });
      }

      // Siempre re-agregar entrada al historial para mantener el control
      window.history.pushState({ page: 'userpanel' }, '', window.location.href);
    };

    // Agregar múltiples entradas al historial como "colchón"
    // Esto previene que el usuario salga de la app con back repetido
    for (let i = 0; i < 3; i++) {
      window.history.pushState({ page: 'userpanel', index: i }, '', window.location.href);
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  // Funciones auxiliares
  /**
   * Carga los veterinarios del usuario usando el nuevo modelo (2026)
   * Usuarios/{userId}/veterinarios[]
   */
  async function loadVeterinariosDeUsuario() {
    const userId = usuarioSeguro.ownerId || usuarioSeguro.id;
    if (!userId) {
      setVeterinarios([]);
      setVetLimites(null);
      return;
    }

    try {
      const resp = await obtenerVeterinariosDeUsuario(userId);

      if (resp.error) {
        console.warn("No se pudieron cargar veterinarios:", resp.error);
        setVeterinarios([]);
        setVetLimites(null);
        return;
      }

      // Backend devuelve: { success, data: { veterinarios, limites } }
      setVeterinarios(resp.data?.veterinarios || []);
      setVetLimites(resp.data?.limites || null);
    } catch (error) {
      console.error("Error al cargar veterinarios:", error);
      setVeterinarios([]);
      setVetLimites(null);
    }
  }

  const getCurrentUserId = () => {
    const token = localStorage.getItem('nfcToken');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.userId || payload.uid;
      } catch (e) {
        console.error('Error decodificando token');
      }
    }
    return usuarioSeguro.ownerId || usuarioSeguro.id;
  };

  // Handlers principales
  function handleMyDataClick() {
    setShowModalDatos(true);
    setMenuAbierto(false);
  }

  async function handleSaveUserData(updated) {
    const success = await saveUserData(updated);
    if (success) {
      setShowModalDatos(false);
      toast.info("Datos guardados correctamente.");
    }
  }

  async function handleSaveAvatar(newAvatar) {
    const success = await changeAvatar(newAvatar);
    if (success) {
      setShowModalAvatar(false);
    }
  }

  function handleEditarObjeto(obj) {
    setObjToEdit(obj);
    setShowEditModal(true);
  }

  async function handleSubmitEdicionObjeto(updatedData) {
    await submitEditObject(updatedData);
    setShowEditModal(false);
  }

  async function handleReportarPerdido(obj) {
    if (obj.extraviado) {
      const result = await reportLostOrFound(obj, { markFound: true });
      if (result?.success) {
        toast.success("¡Objeto encontrado!");
      } else if (result?.error) {
        toast.error("Error: " + result.error);
      }
      return;
    }

    // Mostrar modal de recompensa si tiene acceso (Light, Standard, Premium)
    if (tieneAccesoA(obj, 'recompensa')) {
      setObjToMarkLost(obj);
      setShowRewardModal(true);
    } else {
      // Sin acceso a recompensa - ir directo a pregunta de perfil público
      setObjToMarkLost(obj);
      setPendingRewardData(null);
      setShowPublicProfileModal(true);
    }
  }

  const handleRewardYes = async () => {
    setShowRewardModal(false);
    setLostItemData({ recompensaOfrecida: "", contactoAdicional: "" });
    setShowLostItemForm(true);
  };

  const handleRewardNo = async () => {
    setShowRewardModal(false);
    // No marcar perdido aún - pasar a la pregunta de perfil público
    setPendingRewardData(null); // Sin recompensa
    setShowPublicProfileModal(true);
  };

  async function handleLostItemSubmit(formValues) {
    const result = await submitLostItem(objToMarkLost, formValues);
    if (result) {
      // Recompensa guardada - ahora pasar a la pregunta de perfil público
      setPendingRewardData(formValues);
      setShowLostItemForm(false);
      setLostItemData({});
      setShowPublicProfileModal(true);
    } else {
      // Si falló, no avanzar
      setShowLostItemForm(false);
      setLostItemData({});
      setObjToMarkLost(null);
    }
  }

  // Handlers de perfil público de búsqueda
  const handlePublicProfileYes = () => {
    setShowPublicProfileModal(false);
    // Pre-rellenar ubicación si ya venía de la recompensa
    const initialData = {};
    if (pendingRewardData?.ubicacionPerdida) {
      initialData.ubicacionPerdida = pendingRewardData.ubicacionPerdida;
    }
    setPublicProfileData(initialData);
    setShowPublicProfileForm(true);
  };

  const handlePublicProfileNo = async () => {
    setShowPublicProfileModal(false);
    // Si no tenía recompensa pendiente, marcar como perdido sin recompensa
    if (!pendingRewardData) {
      const result = await reportLostOrFound(objToMarkLost, { wantReward: false });
      if (result.success) {
        toast.warn("Objeto marcado como perdido (sin recompensa)");
      } else if (result.error) {
        toast.error("Error: " + result.error);
      }
    } else {
      // Ya se guardó la recompensa en handleLostItemSubmit, solo informar
      toast.success("Objeto marcado como perdido con recompensa");
    }
    setPendingRewardData(null);
    setObjToMarkLost(null);
  };

  async function handlePublicProfileSubmit(profileFormValues) {
    // Si no tenía recompensa, primero marcar como perdido
    if (!pendingRewardData) {
      const result = await reportLostOrFound(objToMarkLost, { wantReward: false });
      if (!result.success) {
        toast.error("Error: " + (result.error || "No se pudo marcar como perdido"));
        setShowPublicProfileForm(false);
        setPublicProfileData({});
        setObjToMarkLost(null);
        setPendingRewardData(null);
        return;
      }
    }

    // Ahora activar el perfil público
    const result = await submitPublicProfile(objToMarkLost, profileFormValues);
    setShowPublicProfileForm(false);
    setPublicProfileData({});

    if (result) {
      // Mostrar pantalla de éxito con opciones de compartir
      setShowPublicProfileSuccess(true);
    } else {
      toast.warn("Marcado como perdido, pero no se pudo activar el perfil público");
      setObjToMarkLost(null);
    }
    setPendingRewardData(null);
  }

  async function handleToggleBloqueo(obj) {
    const result = await toggleLock(obj);
    
    if (result.showLockModal) {
      setObjToLock(obj);
      setShowLockModal(true);
      return;
    }
  }

  async function handleConfirmLock() {
    if (!objToLock) return;
    
    const result = await toggleLock(objToLock, true);
    
    if (result.success) {
      setShowLockModal(false);
      setObjToLock(null);
    }
  }

  function handleShowCitas(mascota) {
    const token = usuarioSeguro?.token || "";
    navigate(`/userCalendarCitas?token=${token}&uid=${usuarioSeguro.ownerId}&objetoId=${mascota.id}&objetoName=${encodeURIComponent(mascota.nombre)}`);
  }

  function handleShowExpedienteClinico(obj) {
    // Incluir plan para determinar si puede usar IA (solo Premium)
    navigate(`/expedienteClinico?objetoId=${encodeURIComponent(obj.id)}&uid=${usuarioSeguro.ownerId}&token=${usuarioSeguro.token}&plan=${obj.plan || 'light'}`);
  }

  function handleShowCartilla(obj) {
    navigate(`/expedienteClinico?objetoId=${encodeURIComponent(obj.id)}&uid=${usuarioSeguro.ownerId}&token=${usuarioSeguro.token}&plan=${obj.plan || 'light'}&view=cartilla`);
  }

  // Handlers de veterinarios
  /**
   * Crea/invita un veterinario a nivel de usuario (MODELO 2026)
   * El veterinario tendrá acceso a TODAS las mascotas Premium del usuario
   */
  async function handleCreateVet(formData) {
    try {
      const userId = usuarioSeguro.ownerId || usuarioSeguro.id;
      if (!userId) {
        toast.error("No se pudo identificar al usuario");
        return;
      }

      const resp = await invitarVeterinarioAUsuario(userId, formData);

      if (resp.error) {
        toast.error("No se pudo invitar veterinario: " + resp.error);
        return;
      }

      // Backend devuelve: { success, data: { veterinario, limites, esReInvitacion } }
      const vetCreado = resp.data?.veterinario;
      const esReInvitacion = resp.data?.esReInvitacion;

      if (!vetCreado) {
        console.error("Respuesta inesperada del servidor:", resp);
        toast.error("Error: respuesta inesperada del servidor");
        return;
      }

      if (esReInvitacion) {
        toast.info(`${vetCreado.nombre} ya estaba registrado. Se reactivó su acceso.`);
      } else if (vetCreado.estado === "verificado") {
        toast.success(`Veterinario ${vetCreado.nombre} agregado. Tendrá acceso a todas tus mascotas.`);
      } else if (vetCreado.estado === "pendiente") {
        if (formData.correo?.trim()) {
          toast.info(`Invitación enviada a ${formData.correo}. Tendrá acceso a todas tus mascotas.`);
        } else {
          toast.success(`Veterinario guardado (sin envío de invitación).`);
        }
      } else {
        toast.success(`Veterinario guardado (estado: ${vetCreado.estado || 'pendiente'}).`);
      }

      // Actualizar lista y límites
      await loadVeterinariosDeUsuario();

    } catch (error) {
      console.error("Error en handleCreateVet:", error);
      toast.error("Error interno al invitar veterinario.");
    }
  }

  async function handleUpdateVet(vetId, formData) {
    try {
      const resp = await actualizarVeterinario(vetId, formData);
      if (resp.error) {
        toast.error("No se pudo actualizar: " + resp.error);
        return;
      }
      const vetActualizado = resp.data;
      if (vetActualizado.estado === "verificado") {
        toast.info("Veterinario verificado; datos no modificados.");
      } else {
        toast.success("Veterinario actualizado.");
      }
      setVeterinarios((prev) =>
        prev.map((v) => (v.id === vetId ? vetActualizado : v))
      );
    } catch (error) {
      console.error("Error actualizando veterinario:", error);
      toast.error("Error interno al actualizar veterinario.");
    }
  }

  async function handleReInviteVet(vetData) {
    try {
      const resp = await reInvitarVeterinario(vetData.id);
      if (resp.error) {
        toast.error("Error al reenviar invitación: " + resp.error);
        return;
      }
      toast.info(`Reinvitación enviada a ${vetData.correo}`);
      setVeterinarios((prev) =>
        prev.map((v) => (v.id === vetData.id ? resp.data : v))
      );
    } catch (err) {
      console.error("Error reenviando invitación:", err);
      toast.error("Error interno al reenviar invitación.");
    }
  }

  /**
   * Elimina un veterinario del usuario (MODELO 2026)
   * También cancela citas futuras automáticamente
   */
  async function handleDeleteVet(vetId) {
    try {
      const userId = usuarioSeguro.ownerId || usuarioSeguro.id;
      if (!userId) {
        toast.error("No se pudo identificar al usuario");
        throw new Error("Usuario no identificado");
      }

      const resp = await eliminarVeterinarioDeUsuario(userId, vetId);

      if (resp.error) {
        toast.error("Error al eliminar veterinario: " + resp.error);
        throw new Error(resp.error);
      }

      // Mostrar mensaje con información de citas canceladas
      if (resp.citasCanceladas > 0) {
        toast.info(`Veterinario eliminado. Se cancelaron ${resp.citasCanceladas} cita(s) futuras.`);
      } else {
        toast.success("Veterinario eliminado correctamente");
      }

      // Actualizar lista y límites
      await loadVeterinariosDeUsuario();

    } catch (err) {
      console.error("Error eliminando veterinario:", err);
      throw err;
    }
  }

  // Manejo de estados de carga
  if (cargando) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border" 
             style={{color: 'var(--feature-primary)'}} 
             role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  if (errorUsuario) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger rounded-lg"
             style={{borderRadius: 'var(--radius-md)'}}>
          Error: {errorUsuario}
        </div>
      </div>
    );
  }

  if (!usuarioSeguro) {
    return (
      <div className="container mt-5">
        <div className="alert alert-warning rounded-lg"
             style={{borderRadius: 'var(--radius-md)'}}>
          No se encontraron datos de usuario.
        </div>
      </div>
    );
  }

  if (!usuarioSeguro.correoVerificado) {
    return (
      <div className="container mt-5">
        <h2 style={{fontSize: 'var(--font-size-2xl)'}}>
          Hola {usuarioSeguro.nombrePropietario || "Usuario"}
        </h2>
        <p style={{fontSize: 'var(--font-size-base)'}}>
          Debes verificar tu correo antes de usar este panel.
        </p>
      </div>
    );
  }

  // ✅ RENDER PRINCIPAL
  return (
    <>
      {/* 🔒 FIX DEFINITIVO: Forzar overflow hidden en body/html */}
      <style>{`
        html, body {
          overflow: hidden !important;
          height: 100% !important;
        }
      `}</style>

      <div style={{ 
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--gray-50)",
        overflow: "hidden",
        overscrollBehavior: "none"
      }}>
        {/* ✅ HEADER - Ahora como componente separado */}
        <UserPanelHeader
          usuarioSeguro={usuarioSeguro}
          objetos={objetos}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          availableCategories={availableCategories}
          menuAbierto={menuAbierto}
          setMenuAbierto={setMenuAbierto}
          getCurrentUserId={getCurrentUserId}
          onMisDatosClick={() => {
            handleMyDataClick();
          }}
          onCambiarAvatarClick={() => {
            setShowModalAvatar(true);
            setMenuAbierto(false);
          }}
          onVeterinariosClick={() => {
            setShowVetList(true);
            setMenuAbierto(false);
          }}
          onProveedoresClick={() => {
            setShowProvidersList(true);
            setMenuAbierto(false);
          }}
          onAgendaClick={() => setShowAgenda(true)}
          agendaCount={agendaCount}
        />

        {/* ✅ SECCIÓN SCROLLABLE (SOLO CARDS) */}
        <div className="custom-scrollbar" 
             style={{
               flex: 1,
               overflow: "auto",
               overscrollBehavior: 'contain',
               WebkitOverflowScrolling: 'touch',
               padding: 'var(--space-3) var(--space-4)',
               backgroundColor: 'var(--gray-50)'
             }}>
          <div className="container-fluid">
            <div className="row">
              {filteredObjects && filteredObjects.length > 0 ? (
                filteredObjects.map(obj => (
                  <ObjectCard 
                    key={obj.id}
                    objeto={obj}
                    onEditar={handleEditarObjeto}
                    onReportar={handleReportarPerdido}
                    onBloquear={handleToggleBloqueo}
                    onVerExpediente={handleShowExpedienteClinico}
                    onVerCartilla={handleShowCartilla}
                    onShowCitas={handleShowCitas}
                  />
                ))
              ) : (
                <div className="col-12">
                  <div className="card card-body text-center card-elevated"
                       style={{
                         padding: 'var(--space-6)',
                         borderRadius: 'var(--radius-lg)'
                       }}>
                    <i className="bi bi-inbox" 
                       style={{
                         fontSize: 'var(--font-size-4xl)',
                         color: 'var(--gray-400)',
                         marginBottom: 'var(--space-3)'
                       }}></i>
                    <p className="text-muted mb-0"
                       style={{fontSize: 'var(--font-size-base)'}}>
                      {activeFilter === 'todos' 
                        ? "Aún no tienes objetos registrados. ¡Añade tu primer Lemmon Tag!" 
                        : `No tienes objetos en la categoría "${activeFilter}".`}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Modales */}
        <UserPanelModals
          showModalDatos={showModalDatos}
          showModalAvatar={showModalAvatar}
          showEditModal={showEditModal}
          showRewardModal={showRewardModal}
          showLostItemForm={showLostItemForm}
          showVetList={showVetList}
          showProvidersList={showProvidersList}
          showPublicProfileModal={showPublicProfileModal}
          showPublicProfileForm={showPublicProfileForm}
          showPublicProfileSuccess={showPublicProfileSuccess}

          showLockModal={showLockModal}
          setShowLockModal={setShowLockModal}
          objToLock={objToLock}
          setObjToLock={setObjToLock}
          onConfirmLock={handleConfirmLock}
          setShowModalDatos={setShowModalDatos}
          setShowModalAvatar={setShowModalAvatar}
          setShowEditModal={setShowEditModal}
          setShowRewardModal={setShowRewardModal}
          setShowLostItemForm={setShowLostItemForm}
          setShowVetList={setShowVetList}
          setShowProvidersList={setShowProvidersList}
          setShowPublicProfileModal={setShowPublicProfileModal}
          setShowPublicProfileForm={setShowPublicProfileForm}
          setShowPublicProfileSuccess={setShowPublicProfileSuccess}

          userFormData={userFormData}
          lostItemData={lostItemData}
          setLostItemData={setLostItemData}
          publicProfileData={publicProfileData}
          setPublicProfileData={setPublicProfileData}
          objToEdit={objToEdit}
          objToMarkLost={objToMarkLost}
          setObjToMarkLost={setObjToMarkLost}
          veterinarios={veterinarios}
          vetLimites={vetLimites}
          objetos={objetos}

          onSaveUserData={handleSaveUserData}
          onSaveAvatar={handleSaveAvatar}
          onSubmitEdicionObjeto={handleSubmitEdicionObjeto}
          onLostItemSubmit={handleLostItemSubmit}
          onRewardYes={handleRewardYes}
          onRewardNo={handleRewardNo}
          onPublicProfileYes={handlePublicProfileYes}
          onPublicProfileNo={handlePublicProfileNo}
          onPublicProfileSubmit={handlePublicProfileSubmit}
          onCreateVet={handleCreateVet}
          onUpdateVet={handleUpdateVet}
          onReInviteVet={handleReInviteVet}
          onDeleteVet={handleDeleteVet}

          usuarioSeguro={usuarioSeguro}
          LOST_ITEM_FIELDS={LOST_ITEM_FIELDS}
          PUBLIC_PROFILE_FIELDS={PUBLIC_PROFILE_FIELDS}
          getCurrentUserId={getCurrentUserId}
          avatarsDisponibles={avatarsDisponibles}
        />
        
        {/* Mi Agenda - Hub unificado */}
        <MiAgendaModal
          show={showAgenda}
          onClose={() => setShowAgenda(false)}
          onCountChange={fetchAgendaCount}
        />

        {/* Asistente IA - Disponible para Standard/Premium mascotas y Premium objetos con plan vigente */}
        {objetos.some(o => tieneAccesoA(o, 'asistenteIA')) && (
          <SoportePanel usuario={usuarioSeguro} />
        )}
        
        {/* Toasts - render via portal to ensure they appear above all modals */}
        {createPortal(
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            theme="light"
            enableMultiContainer={false}
            draggable={false}
            style={{ zIndex: 9999999 }}
          />,
          document.body
        )}
      </div>
      <SessionWarningModal
      show={showWarning}
      secondsRemaining={secondsRemaining}
      onExtendSession={extendSession}
      onLogoutNow={logoutNow}
    />
    </>
  );
}